import { render, staticRenderFns } from "./Herramientas.vue?vue&type=template&id=70f288ee&scoped=true"
import script from "./Herramientas.vue?vue&type=script&lang=js"
export * from "./Herramientas.vue?vue&type=script&lang=js"
import style0 from "./Herramientas.vue?vue&type=style&index=0&id=70f288ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f288ee",
  null
  
)

export default component.exports